import React, { useState } from 'react';
import bemCn from 'bem-cn';
import { AUTH_TESTS } from '../../pages/listings/auth-test.const';
import NavGuestMobileUnauthSSR from '../navigation-guest-unauth/mobile-ssr';
import NavigationGuestUnauth from '../navigation-guest-unauth/desktop-ssr';
import NavigationLayoutSSR from '../navigation-layout/layout-ssr';
import SvgBarsSolid from 'src/assets/svg/SvgBarsSolid.svg';
import SvgFilterNew from 'src/assets/svg/SvgFilterNew.svg';
import SvgSearch from 'src/assets/svg/SvgSearch.svg';
import SvgCross2 from 'src/assets/svg/SvgCross2.svg';
import SvgList from 'src/assets/svg/SvgList.svg';
import SvgMap from 'src/assets/svg/SvgMap.svg';
import './header.scss';

const b = bemCn('navigation-guest');

const SeoCitySingleHeader = ({
    city,
    state,
    general,
    isMapView,
    getAuthTest,
    toggleMapView,
    filterCounts,
    isAvailabilityQuickFilterTest,
    searchBarText,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const searchText =
        searchBarText || (general ? 'Search location' : state?.name || `${city?.name}, ${city?.stateShort?.toUpperCase() || city?.state}`);

    const toggleMenu = (e) => {
        e?.nativeEvent?.stopImmediatePropagation();
        setIsOpen(!isOpen);
    };

    const handleFilter = (e) => {
        e.stopPropagation();
        getAuthTest(AUTH_TESTS.TOGGLE_FILTERS);
    };

    return (
        <>
            <NavigationGuestUnauth />
            <NavigationLayoutSSR className="is-listing mob-show d-flex d-md-none" style={{ height: '72px' }}>
                <div className="w-100 h-100 d-flex justify-content-between align-items-center">
                    <div className={b('search-bar-menu')} onClick={toggleMenu}>
                        {isOpen ? <SvgCross2 width={24} height={24} /> : <SvgBarsSolid width={24} height={24} />}
                    </div>
                    <NavGuestMobileUnauthSSR active={isOpen} handleLeave={toggleMenu} useState={useState} isListing />
                    <div className={b('search-bar')}>
                        <div className={b('search-bar_input')} onClick={() => getAuthTest(AUTH_TESTS.TOGGLE_SEARCH)}>
                            <SvgSearch />
                            <div className={b('search-bar_input_text-container')}>
                                <div className="snif-s1">{searchText}</div>
                                {isAvailabilityQuickFilterTest !== true && (
                                    <>
                                        <div className="d-none d-md-block mx-1">/</div>
                                        <div className="snif-s2 snif-s1-pc">
                                            <span>Any date</span>•<span>Any time</span>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className={b('search-bar_input_count')} onClick={handleFilter}>
                                <SvgFilterNew />
                                <div className="green-dot">{filterCounts || 1}</div>
                            </div>
                        </div>
                        <div onClick={toggleMapView}>{isMapView ? <SvgList /> : <SvgMap />}</div>
                    </div>
                </div>
            </NavigationLayoutSSR>
        </>
    );
};

export default SeoCitySingleHeader;
